// test1524
(1524 && 0);
